export default __webpack_public_path__ + "static/media/background_5_large.b064adc7.jpg";